import {Http} from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';

 
 import 'rxjs/add/operator/map';
  export class DataService {  
  public response3:any;

  
    static get parameters() {
        return [[Http]];
    }
  // urldom: string = "http://app.fotopoint.hr/upravitelj/";
 // -- >>urldom: string = "https://app.fotopoint.hr/demowupravitelj/";
   urldom: string = "https://app.fotopoint.hr/wupravitelj/";
  constructor(private http:Http) {
   }

// serviceAllDrugiDohPregledPhp(pom_selvrdokm,pom_selulazm,pom_selposppart,datumod,datumdo ) {
//     if (pom_selvrdokm === undefined ) {
//     pom_selvrdokm ="" ;
//    }
//     if (pom_selulazm === undefined ) {
//     pom_selulazm ="" ;
//    }
//     if (pom_selposppart === undefined ) {
//     pom_selposppart ="" ;
//    }
//    if (datumod === undefined ) {
//      datumod ="" ;
//    }
//    if (datumdo === undefined ) {
//     datumdo ="" ;
//    }
//    var url =  this.urldom+'S_drugidohodakp.php?'
//    +'&vrdokumenta="'+pom_selvrdokm+'"'
//   +'&brojulaza="'+pom_selulazm+'"'
//   +'&kupdob="'+pom_selposppart+'"'
//   +'&datumod="'+datumod+'"'
//   +'&datumdo="'+datumdo+'"'
//     console.log(" serviceAllRacunOPregledPhp "+url) ;
//     var response = this.http.get(url).map(res => res.json());
//     this.http.get(url).subscribe(res => { console.log(res); });
//       return response;
//   }


// http://app.fotopoint.hr/demowupravitelj/S_wkorcombo.php?vrkor="A"&brkor="12"
serviceAllWKorisnikPhp(par_vrkor : string , par_brkor : string  ) {
 //  pom_selvrdokm="51" ;
    if (par_vrkor === undefined ) {
    par_vrkor ="" ;
   }
    if (par_brkor === undefined ) {
    par_brkor ="" ;
   }
    
  //  -- console.log(" urldom....."+this.urldom) ;
  var url =  this.urldom+'S_wkorcombo.php'
  //  var url =  this.urldom  +'S_racunupraviteljp.php?'
  +'?vrkor="'+par_vrkor +'"'
  +'&brkor="'+par_brkor+'"'
  
    // console.log(" serviceAllWKorisnikPhp "+url) ;
    var response = this.http.get(url).map(res => res.json());
    this.http.get(url).subscribe(res => { // console.log(res); ž
    });
      return response;
  }


// http://app.fotopoint.hr/demowupravitelj/S_wkorpregled.php?vrsta="A"&ulaz=0&stan=4175&kupdob=3893&datumod="01.01.2018"&datumdo="31.12.2018"
//  serviceWkorpregledPhp(vrsta : string,ulaz : number,stan : number ) {
//    var url =   this.urldom+ 'S_wkorpregled.php'
//   +'?vrsta="'+vrsta+'"'
//   +'&ulaz=0'
//   +'&stan="'+stan+'"'
//   +'&kupdob=""'
//   +'&datumod="01.01.2018"'
//   +'&datumdo="31.12.2018"'
 
  
  
//     console.log(" .. serviceWkorpregledPhp() "+url) ;
//     var response = this.http.get(url).map(res => res.json());
//     this.http.get(url).subscribe(res => { console.log(res); });
//       return response;
//   }

// http://app.fotopoint.hr/demowupravitelj/S_wkorpregleda.php?stan=4175&kupdob=3893&datumod="01.01.2018"&datumdo="31.12.2018"
 // stanar 
 serviceWkorpregledPhp(stan : number ) {
 //  -- console.log(" urldom....."+this.urldom) ;

 var url =   this.urldom+ 'S_wkorpregleda.php'
 +'?stan="'+stan+'"'
 +'&kupdob=""'
 +'&datumod=""'
 +'&datumdo=""'

    
   //  console.log(" .. serviceWkorpregledPhp() ::::::>>>"+url) ;
    var response = this.http.get(url).map(res => res.json());
    this.http.get(url).subscribe(res => { //  console.log(res);
     });
      return response;
  }

// http://app.fotopoint.hr/demowupravitelj/S_wkorpregledb.php?ulaz=1&kupdob=4759&datumod="01.01.2018"&datumdo="31.12.2018"
 // majstori 
 serviceWmajstorpregledPhp(majstor : string ,ulaz : number, ) {
 //  -- console.log(" urldom....."+this.urldom) ;

 var url =   this.urldom+ 'S_wkorpregledb.php'
 +'?ulaz="'+ulaz+'"'
 +'&kupdob="'+majstor+'"'
 +'&datumod=""'
 +'&datumdo=""'
    
    //console.log(" .. serviceWmajstorpregledPhp "+url) ;
    var response = this.http.get(url).map(res => res.json());
    this.http.get(url).subscribe(res => { //console.log(res); 
    });
    return response;
  }

  // http://app.fotopoint.hr/demowupravitelj/S_wkorpregledc.php?vrsta="1"&ulaz=2&kupdob=4759&datumod="01.01.2018"&datumdo="31.12.2018"
 // predstavnik 
 //  +'?vrsta="1"' drugi dohodak , itd druge vrste 
 // http://app.fotopoint.hr/demowupravitelj/S_wkorpregledc.php?vrsta="2"&ulaz=""&stan=4483&kupdob=""&datumod="01.01.2019"&datumdo=""
 serviceWpredstavnikpregledPhp(ulaz : number ,vrsta : string,kupdob :string , datumod : string , datumdo : string,stan : number) {
 //  -- console.log(" urldom....."+this.urldom) ;
 if (kupdob==undefined) {
  kupdob="";
 }
 if (datumod==undefined) {
  datumod="";
 }
 if (datumdo==undefined) {
  datumdo="";
 }
 var url =   this.urldom+ 'S_wkorpregledc.php'
 +'?vrsta="'+vrsta+'"'
 +'&ulaz="'+ulaz+'"'
 +'&stan="'+stan+'"'
 +'&kupdob="'+kupdob+'"'
 +'&datumod="'+datumod+'"'
 +'&datumdo="'+datumdo+'"'
   
   //    console.log(" .. >> serviceWpredstavnikpregledPhp "+url) ;
    var response = this.http.get(url).map(res => res.json());
    this.http.get(url).subscribe(res => { 
     //   console.log(res);
     });
    return response;
  }

  // http://app.fotopoint.hr/demowupravitelj/S_wkorpregledzbirni.php?vrsta="2"&ulaz=155&kupdob=""&datumod="01.01.2020"&datumdo="31.12.2020"
  serviceWpredstavnikpregledZbirniPhp(ulaz : number ,vrsta : string,kupdob :string , datumod : string , datumdo : string) {
    //  -- console.log(" urldom....."+this.urldom) ;
    if (kupdob==undefined) {
     kupdob="";
    }
    if (datumod==undefined) {
     datumod="";
    }
    if (datumdo==undefined) {
     datumdo="";
    }
    var url =   this.urldom+ 'S_wkorpregledzbirni.php'
    +'?vrsta="'+vrsta+'"'
    +'&ulaz="'+ulaz+'"'
    +'&kupdob="'+kupdob+'"'
    +'&datumod="'+datumod+'"'
    +'&datumdo="'+datumdo+'"'
      
      //    console.log(" .. serviceWpredstavnikpregledZbirniPhp "+url) ;
       var response = this.http.get(url).map(res => res.json());
       this.http.get(url).subscribe(res => { 
        //   console.log(res);
        });
       return response;
     }

  // Izbacio Bero 01.10.2019 
  // getPospPartTypeAhead() {
  //   var url = this.urldom+'S_poslpartcombo.php?firma=1'
  // // var url = 'http://app.fotopoint.hr/upravitelj/S_nazivpredstavnika.php';
  
  //     console.log("----getPospPartTypeAhead()" + url) ;
  //        return this.http.get(url).map(res => res.json());
  //   }
  // ubacio Bero 01.10.2019 
 getPospPartTypeAhead(vrsta : string ,ulaz : number ) {
    var url = this.urldom+'S_wposlpartcombo.php'
    +'?vrsta="'+vrsta+'"'
    +'&ulaz="'+ulaz+'"'
    
    
   
  // var url = 'http://app.fotopoint.hr/upravitelj/S_nazivpredstavnika.php';
  
    //   console.log("----getPospPartTypeAhead()" + url) ;
         return this.http.get(url).map(res => res.json());
    }



getUlazTypeAhead() {
  var url = this.urldom+'S_ulazcombo.php?firma=1'
// var url = this.urldom+'S_nazivpredstavnika.php';
    //console.log("----getUlazTypeAhead()" + url) ;
       return this.http.get(url).map(res => res.json());
  }

//////////
//////////////////////////////////////////////////////////

 ispisiPregObrJson(dataListCtrl) {

   var sendctrl ="[" ;
    for (var i = 0; i < dataListCtrl.length; i++) {
       sendctrl = sendctrl +'' + dataListCtrl[i].Broj 
       if (i<dataListCtrl.length-1){
        sendctrl = sendctrl +',' ;
       } 
          //console.log("--ispisiPregObrJson u service   "  + dataListCtrl[i].Broj)  ;    
  //  this.readMyData() ;
      }
 sendctrl =sendctrl +"]" ;
 //console.log("-- sendctrl  "  +  sendctrl)  ;    
  let headers = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
  let options = new RequestOptions({headers: headers});

   //  var url = '-----http://app.fotopoint.hr/upravitelj/S_racunstanpregledpc.php?inda1="D"'
   //  +'&broj=0'
    // +'&ulaz=""'
    // +'&stan=0'
//  sendctrl = '"test za beru "' ;
    var url = this.urldom+'S_racunjson.php?'   
      +'areajson='+ '"' + sendctrl +'"';
  // var url = 'assets/mytestfile.json '
// http://app.fotopoint.hr/upravitelj/S_racunjson.php?areajson='["700","701","702","703","704"]'
 //  console.log(" -->>>>> ,,,,, ispisiPregObrJson "+url) ;
      var response = this.http.get(url).map(res => res.json());
       this.http.get(url).subscribe(res => { //console.log(res);
       });
        return response;



    //  this.http.post(url, JSON.stringify(dataListCtrl), options) ;
}
/////////////////////////////////////////////
//////////////
ispisiPregObrJsonPlin(dataListCtrl) {
 var sendctrl ="[" ;
  for (var i = 0; i < dataListCtrl.length; i++) {
     sendctrl = sendctrl +'' + dataListCtrl[i].Broj 
     if (i<dataListCtrl.length-1){
      sendctrl = sendctrl +',' ;
     } 
        //console.log("-->>>>> ispisiPregObrJsonPlin u service   "  + dataListCtrl[i].Broj)  ;    
//  this.readMyData() ;
    }
sendctrl =sendctrl +"]" ;
//console.log("-- sendctrl  "  +  sendctrl)  ;    
let headers = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
let options = new RequestOptions({headers: headers});

 //  var url = '-----http://app.fotopoint.hr/upravitelj/S_racunstanpregledpc.php?inda1="D"'
 //  +'&broj=0'
  // +'&ulaz=""'
  // +'&stan=0'
//  sendctrl = '"test za beru "' ;

   var url = this.urldom+'S_racunjsonplin.php?'   
// -- >>  var url = this.urldom+'S_racunjson.php?'   
    +'areajson='+ '"' + sendctrl +'"';
// var url = 'assets/mytestfile.json '
// http://app.fotopoint.hr/upravitelj/S_racunjson.php?areajson='["700","701","702","703","704"]'
 //console.log(" -- ,,,,,,,,, ispisiPregObrJsonPlin "+url) ;
    var response = this.http.get(url).map(res => res.json());
     this.http.get(url).subscribe(res => { //console.log(res); 
    });
      return response;
  //  this.http.post(url, JSON.stringify(dataListCtrl), options) ;
}




////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////




sleep(milliseconds) {
//  this.updateCount();
  var start = new Date().getTime();
  for (var i = 0; i < 1e7; i++) {
    if ((new Date().getTime() - start) > milliseconds){
      break;
    }
  }
}


// 
// registracija  ---  http://app.fotopoint.hr/demowupravitelj/S_wkorloginregistracija.php?username="8"&broj="3215-180501-8"&password="791p"
serviceWRegistracijaPhp(korime: string, pozivnabroj : string , lozinka: string) {
     var url =   this.urldom+ 'S_wkorloginregistracija.php'
        +'?username="'+korime+'"'
        +'&broj="'+pozivnabroj+'"'
        +'&password="'+lozinka+'"'
    //console.log(" .. S_wkorloginregistracija.php "+url) ;
     var response = this.http.get(url).map(res => res.json());
  //    this.http.get(url).subscribe(res => { console.log(res); });
     return response;
   }

// 
// izmjena  ---  http://app.fotopoint.hr/demowupravitelj/S_wkorloginizmjena.php?username="8"&passwords="791p"&passwordn="7777"
 serviceWIzmjenaLozPhp(korime: string, lozinka : string , lozinkanova: string) {
   var url =   this.urldom+ 'S_wkorloginizmjena.php'
      +'?username="'+korime+'"'
     +'&passwords="'+lozinka+'"'
      +'&passwordn="'+lozinkanova+'"'
  //console.log(" .. S_wkorloginizmjena.php "+url) ;
   var response = this.http.get(url).map(res => res.json());
 //   this.http.get(url).subscribe(res => { console.log(res); });
   return response;
 }

 // http://app.fotopoint.hr/demowupravitelj/S_wkorloginkreiranje.php?username="8"
 serviceWZaboraviliLozPhp(korime: string) {
  var url =   this.urldom+ 'S_wkorloginkreiranje.php'
     +'?username="'+korime+'"'
   
 //console.log(" .. S_wkorloginizmjena.php "+url) ;
  var response = this.http.get(url).map(res => res.json());
//   this.http.get(url).subscribe(res => { console.log(res); });
  return response;
}

}


// WEBPACK FOOTER //
// ./src/app/myservice/data-service.ts